import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=03f613f6&"
import script from "./checkbox-group.vue?vue&type=script&lang=js&"
export * from "./checkbox-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03f613f6')) {
      api.createRecord('03f613f6', component.options)
    } else {
      api.reload('03f613f6', component.options)
    }
    module.hot.accept("./checkbox-group.vue?vue&type=template&id=03f613f6&", function () {
      api.rerender('03f613f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/checkbox-group/checkbox-group.vue"
export default component.exports